import React from 'react';
import { FormattedMessage } from 'react-intl';

import { renderFormBasedOnType } from '../../../../../../services/filtering/filter-form-render-service';
import { OptionFormTypes } from '../../../../../../services/filtering/filter-form-render-service/option-form-types';
import { messages } from '../messages';

export const statusFilter = {
  id: 'status',
  displayName: <FormattedMessage {...messages.statusColumnHeader} />,
  type: OptionFormTypes.TYPE_CHECKLIST,
  filterValue: 'statusList',
  shouldHideActionButtons: false,
  expectsArgumentAsArray: true,
  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },
};
